import React from "react";
import _ from "lodash";
import PriceUnit from "./PriceUnit";
import PriceEditor from "./PriceEditor";
import PriceLimitHint from "./PriceLimitHint";

import { isPricesInvalid, PRICE_TYPE } from "./UPRSegmentationHelper";

import { FaPlus } from "react-icons/fa";

class PriceSettingControl extends React.Component {
  constructor(props) {
    super(props);

    // prices: array of number
    // limit: { min, max }
    const { prices, preventInitCheck = true } = this.props;

    this.state = {
      prices,
      editIdx: -1,
      editType: PRICE_TYPE.FLOOR,
      editInput: "",

      preventInitCheck,
      isInvalid: false,
      isEdit: false,
      errMsg: null,
    };

    this.handleUnitAdd = this.handleUnitAdd.bind(this);
    this.handleUnitClicked = this.handleUnitClicked.bind(this);
    this.handleUnitDeleted = this.handleUnitDeleted.bind(this);
    this.handleApplyEdit = this.handleApplyEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
  }

  componentDidMount() {
    if (this.props.prices) {
      this.isPricesInvalid(this.props.prices);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.limit, this.props.limit)) {
      this.isPricesInvalid(this.state.prices);
    }

    if (!_.isEqual(prevState.prices, this.state.prices)) {
      if (this.props.handleSync) {
        this.props.handleSync(this.state.prices);
      }
    }
  }

  handleUnitAdd() {
    const { prices } = this.state;
    this.setState({
      isEdit: true,
      editIdx: prices.length,
    });
  }

  handleUnitClicked(idx) {
    this.setState({
      editIdx: idx,
      isEdit: true,
    });
  }

  handleUnitDeleted(idx) {
    const { prices, editIdx } = this.state;

    // reset editIdx if the deleted idx is the current editing idx
    if (editIdx === idx) this.setState({ isEdit: false, editIdx: -1 });

    // adjust editIdx if the deleted idx is before the current editing idx
    if (editIdx > idx) this.setState({ editIdx: editIdx - 1 });

    const list = _.filter(prices, (_, i) => i !== idx);
    this.setState({ preventInitCheck: false }, () => {
      this.isPricesInvalid(list);
    });

    this.setState(
      {
        prices: list,
      },
      () => {
        if (this.props.handlePricesChanged) {
          this.props.handlePricesChanged(this.state.prices);
        }
      }
    );
  }

  handleApplyEdit(price) {
    const { editIdx, prices } = this.state;
    const list = [...prices];
    list[editIdx] = price;

    this.setState({ preventInitCheck: false }, () => {
      this.isPricesInvalid(list);
    });

    this.setState(
      {
        isEdit: false,
        editIdx: -1,
        prices: list,
      },
      () => {
        if (this.props.handlePricesChanged) {
          this.props.handlePricesChanged(this.state.prices);
        }
      }
    );
  }

  handleCancelEdit() {
    this.setState({
      isEdit: false,
      editIdx: -1,
    });
  }

  isPricesInvalid(prices) {
    const { limit } = this.props;
    const { isInvalid, errMsg } = isPricesInvalid({ prices, limit });
    if (!this.state.preventInitCheck) this.setState({ isInvalid, errMsg });
    if (this.props.handleValidChanged) {
      this.props.handleValidChanged(!isInvalid);
    }
  }

  render() {
    const {
      limit,
      supportAlgo = false,
      showErrMsg = true,
      showTooltip = true,
    } = this.props;
    const { prices, isInvalid, isEdit, errMsg, editIdx } = this.state;

    // limit.options: [5,10] (num of prices could only be 5 or 10)
    const { min, max } = limit;

    const dontNeedPrices = min === 0 && max === 0;

    return (
      <div>
        <div className="mb-4">
          {dontNeedPrices ? (
            <div>dt does not required prices</div>
          ) : (
            <div>
              <PriceLimitHint limit={limit}></PriceLimitHint>
              <div className="border rounded border-gray-400 bg-white p-2">
                <div className="flex flex-wrap items-center gap-2">
                  {prices &&
                    prices.map((p, idx) => {
                      return (
                        <PriceUnit
                          price={p}
                          key={`${idx}-${p}`}
                          selected={editIdx === idx}
                          tooltip={showTooltip ? idx + 1 : undefined}
                          handleUnitDeleted={() => this.handleUnitDeleted(idx)}
                          handleUnitClicked={() => this.handleUnitClicked(idx)}
                        ></PriceUnit>
                      );
                    })}
                  <div
                    className={`border rounded cursor-pointer border-dashed  text-sm  ${
                      editIdx === prices.length
                        ? "border-blue-400 bg-blue-400 text-white"
                        : "border-gray-400 text-blue-600 hover:text-blue-700"
                    }`}
                    style={{ padding: "0.4rem" }}
                    onClick={() => this.handleUnitAdd()}
                  >
                    <FaPlus />
                  </div>
                </div>
                {isEdit && (
                  <div className="border-t mt-2 border-gray-400 p-2">
                    <PriceEditor
                      price={prices[editIdx]}
                      supportAlgo={supportAlgo}
                      handleApply={(value) => this.handleApplyEdit(value)}
                      handleCancel={() => this.handleCancelEdit()}
                    ></PriceEditor>
                  </div>
                )}
              </div>

              <div className="text-xs text-gray-700">
                {(prices && prices.length) || 0} prices
              </div>

              {isInvalid && showErrMsg && (
                <div className="bg-red-100 px-2 font-semibold text-red-700">
                  {errMsg}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PriceSettingControl;
